import { createApiAction } from '@app/packages/api/utils'
import type { V3PostSupportGuestSessionResponse, V3PostSupportSessionResponse } from '@app/packages/api/v3/types/responses'

/** Guarantees the caller a support channel and returns its id. Idempotent; `429` past 10/hour or 50/day. */
export const postSupportSession = () =>
  createApiAction('postSupportSession', dispatch =>
    dispatch<V3PostSupportSessionResponse>({
      endpoint: '/api/v3/support/session',
      method: 'POST',
    })
  )

/**
 * Raises a guest support chat session: visitor, support channel bridged to
 * amoCRM, bot greeting, chat token. Idempotent by the httpOnly cookie the
 * server sets, so this doubles as the token refresh — there is no separate one.
 */
export const postSupportGuestSession = () =>
  createApiAction('postSupportGuestSession', dispatch =>
    dispatch<V3PostSupportGuestSessionResponse>({
      endpoint: '/api/v3/support/guest_session',
      method: 'POST',
      // The dispatcher defaults to 'omit', and the browser then discards the
      // Set-Cookie carrying the guest session key.
      credentials: 'same-origin',
    })
  )
